module.exports = __webpack_public_path__ + "img/chrome-2.3aab6c73.webp";